module.exports = __webpack_public_path__ + "media/src/img/payment/bakai_logo-2e1136facb6ad876d0010004fe1c592d.png";